import { createReducer, on } from '@ngrx/store'
import { ActionProgressDialogActions } from './action-types'

const INIT_STATE: IActionProgressDialogState = {
    show: false,
    text: null,
}

export const ActionProgressDialogReducer = createReducer(
    INIT_STATE,
    on(ActionProgressDialogActions.setShow, (state, { show, text }): IActionProgressDialogState =>
        ({ ...state, show, text: text || null }),
    ),
    on(ActionProgressDialogActions.setText, (state, { text }): IActionProgressDialogState =>
        ({ ...state, text }),
    ),
    on(ActionProgressDialogActions.resetState, (): IActionProgressDialogState => INIT_STATE),
    on(ActionProgressDialogActions.resetShow, (state): IActionProgressDialogState => {
        return { ...state, show: INIT_STATE.show }
    }),
    on(ActionProgressDialogActions.resetText, (state): IActionProgressDialogState => {
        return { ...state, text: INIT_STATE.text }
    }),
)

export interface IActionProgressDialogState {
    show: boolean;
    text: string;
}